<div fxLayout="row">
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex.gt-sm="50" class="content" ngClass.gt-sm="desktop" ngClass.sm="padding sm" ngClass.xs="xs">
        <div fxLayout="column" fxFlexOffset.gt-md="30" fxFlex.gt-sm="60" fxFlex.lt-lg="100">
            <div class="intro-title">Marine Radioactivity Information System</div>
            <div>
                <div class="intro-sub-title">
                    The IAEA Marine Radioactivity Information System (MARIS) allows free access to users to search and download the results of measurements of radioactivity in seawater, biota,
                    sediment and suspended matter. MARIS is maintained and developed by the IAEA Environment Laboratories in Monaco.
                </div>
            </div>

            <div fxLayout="row">
                <div class="intro-btn-wrapper white" fxLayout="row" fxLayoutAlign="center center">
                    <a routerLink="/explore" class="intro-btn"> Explore data </a>
                </div>
                <div class="intro-btn-wrapper blue" fxLayout="row" fxLayoutAlign="center center">
                    <a routerLink="/datasets" class="intro-btn-primary"> View datasets </a>
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="column" fxFlex.gt-sm="50" fxHide.lt-md class="intro-cover"></div>
</div>

<div id="container" *ngIf="showDialog" class="display-dialog">
    <div class="dialog">
        <div *ngComponentOutlet="activeComponent"></div>
    </div>
</div>
